import { HorizontalLogo } from '@components/atoms/logo/horizontalLogo';
import { useEffect, useState } from 'react';

type SplashScreenProps = {
  show: boolean;
};

export function SplashScreen({ show }: SplashScreenProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setIsVisible(false);
      }, 300);
    }
  }, [show]);

  if (!isVisible) return <></>;

  return (
    <div
      role="presentation"
      className={`fixed inset-0 z-50 flex justify-center items-center bg-primary-gradient transition ease-in duration-300 ${show ? 'opacity-100' : 'opacity-0'}`}
    >
      <HorizontalLogo
        className="w-[90%] max-w-[580px] h-auto px-4 sm:w-[80%] md:w-[70%] lg:w-[580px]"
        preserveAspectRatio="xMidYMid meet"
      />
    </div>
  );
}
